import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeNumbers01 from './HomeNumbers_01';
import HomeNumbers02 from './HomeNumbers_02';
import HomeNumbers03 from './HomeNumbers_03';
import HomeNumbers04 from './HomeNumbers_04';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        <>
            {
            layout.current === 'home-numbers-01' ?
                <HomeNumbers01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-numbers-02' ?
                <HomeNumbers02 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-numbers-03' ?
                <HomeNumbers03 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-numbers-04' ?
                <HomeNumbers04 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
                <HomeNumbers01 pag_welcome={pw.current} dados_config={dados_config.current} />
            }
        </>
    )
}
